/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Group_DayInputs */

const vi_warehouse_sales_group_day = /** @type {(inputs: Warehouse_Sales_Group_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày`)
};

/**

* @param {Warehouse_Sales_Group_DayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_group_day = /** @type {((inputs?: Warehouse_Sales_Group_DayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Group_DayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_group_day(inputs)
});